import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    requestAnimationFrame(() => {
      this.element.focus()
      const end = this.element.value.length
      this.element.setSelectionRange(end, end)
    })
  }
}
